export default __webpack_public_path__ + "static/peepal-150x105-4175100c88b655336db2ae168df28f75.png";